import pxToEm from '@shared/components/mixins/shared/pxToEm'

export default {
  name: 'ButtonComponent',
  props: {
    component: {
      type: Object,
      required: true,
    },
  },
  mixins: [pxToEm],
  methods: {
    btnClick(action) {
      if (action === 'next' || action === 'prev') {
        // Go to next/prev page
        this.$eventBus.$emit('trigger-change-step', action)
      } else if (action === 'wheelSpin') {
        this.$eventBus.$emit('trigger-wheel-spin-validation')
      } else if (action === 'close') {
        this.$eventBus.$emit('close')
      } else if (action === 'reload') {
        window.location.reload()
      } else if (this.component.settings.href.length > 0) {
        if (this.component.settings.action === 'url') {
          window.open(this.component.settings.href)
        } else if (this.component.settings.action === 'email') {
          window.location.href = 'mailto:' + this.component.settings.href +
            '?subject=&body='
        } else if (this.component.settings.action === 'jump') {
          // Go to specified page
          this.$eventBus.$emit('trigger-change-step',
            this.component.settings.href)
        }
      }
    },
  },
}
